var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReplaceImage = function SvgReplaceImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3v2.27C17.2 3.84 14.7 3 12 3 8.13 3 4.84 5.13 3.18 8.25l1.86.94C6.33 6.69 8.96 5 12 5c2.06 0 3.93.74 5.35 2H14v2h7V2h-2ZM3 11v11h18V11Zm2 2h14v4.59l-2.29-2.3-.71-.7-2.5 2.5-2.79-2.8-.71-.7-5 5Zm11 1.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5m-6 1.91L14.59 21H5v-.59Zm6 1 3 3V21h-2.59l-1.5-1.5Z"
  })));
};
export default SvgReplaceImage;